module.exports = __webpack_public_path__ + "assets/crowd.59a46f23.svg";